/* =====================================================================
   product-tech.js
   - サムネイル切替 (preload + 即時反映)
   - タブ / プリセット
   - data-scroll-target を持つボタン: 該当アンカーへスムーズスクロール
===================================================================== */
(function () {
  'use strict';

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function preload(url) {
    if (!url) return;
    var img = new Image();
    img.src = url;
  }

  function setupGallery(root) {
    var gallery = root.querySelector('.ptech-pt__gallery');
    if (!gallery) return;
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('.ptech-pt__thumb'));
    var mainWrap = gallery.querySelector('.ptech-pt__main-wrap');
    var dots = Array.prototype.slice.call(gallery.querySelectorAll('.ptech-pt__dots span'));
    if (!mainWrap || !thumbs.length) return;

    /* 画像サムネの拡大版を事前ロード (動画はpreload属性に委譲) */
    thumbs.forEach(function (t) {
      if ((t.dataset.mediaType || 'image') === 'image') preload(t.dataset.large);
    });

    var current = 0;

    function getMainEl() {
      return mainWrap.querySelector('.ptech-pt__main-img, .ptech-pt__main-video');
    }

    function showImage(src, alt) {
      var existing = getMainEl();
      var img = document.createElement('img');
      img.className = 'ptech-pt__main-img';
      img.src = src;
      img.alt = alt || '';
      img.loading = 'eager';
      img.decoding = 'async';
      if (existing) existing.replaceWith(img);
      else mainWrap.appendChild(img);
    }

    function showVideo(src, poster) {
      var existing = getMainEl();
      var vid = document.createElement('video');
      vid.className = 'ptech-pt__main-video';
      vid.src = src;
      if (poster) vid.poster = poster;
      vid.autoplay = true;
      vid.loop = true;
      vid.muted = true;
      vid.playsInline = true;
      vid.setAttribute('playsinline', '');
      vid.preload = 'auto';
      if (existing) existing.replaceWith(vid);
      else mainWrap.appendChild(vid);
      var p = vid.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    }

    function activate(idx) {
      if (idx < 0) idx = thumbs.length - 1;
      if (idx >= thumbs.length) idx = 0;
      current = idx;
      thumbs.forEach(function (t, i) { t.classList.toggle('active', i === idx); });
      dots.forEach(function (d, i) { d.classList.toggle('on', i === idx); });
      var thumb = thumbs[idx];
      var mediaType = thumb.dataset.mediaType || 'image';

      if (mediaType === 'video' && thumb.dataset.videoSrc) {
        showVideo(thumb.dataset.videoSrc, thumb.dataset.large);
      } else {
        var large = thumb.dataset.large || (thumb.tagName === 'IMG' ? thumb.src : '');
        var alt = thumb.tagName === 'IMG' ? thumb.alt : '';
        showImage(large, alt);
      }
    }

    thumbs.forEach(function (thumb, idx) {
      thumb.addEventListener('click', function () { activate(idx); });
    });

    /* モバイル: 横スワイプ + ドットタップ */
    if (mainWrap) {
      var startX = null, startY = null, dx = 0, dy = 0;
      mainWrap.addEventListener('touchstart', function (e) {
        var t = e.changedTouches[0];
        startX = t.clientX; startY = t.clientY; dx = 0; dy = 0;
      }, { passive: true });
      mainWrap.addEventListener('touchmove', function (e) {
        if (startX == null) return;
        var t = e.changedTouches[0];
        dx = t.clientX - startX;
        dy = t.clientY - startY;
      }, { passive: true });
      mainWrap.addEventListener('touchend', function () {
        if (startX == null) return;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          activate(current + (dx < 0 ? 1 : -1));
        }
        startX = null;
      }, { passive: true });
    }

    dots.forEach(function (dot, idx) {
      dot.addEventListener('click', function () { activate(idx); });
      dot.style.cursor = 'pointer';
    });
  }

  function setupTabs(root) {
    var tabs = root.querySelectorAll('.ptech-tab');
    if (!tabs.length) return;
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('active'); });
        tab.classList.add('active');
        var targetId = tab.dataset.target;
        if (!targetId) return;
        var target = document.getElementById(targetId);
        if (!target) return;
        scrollToEl(target);

        if (targetId.indexOf('ptechSupport-') === 0) {
          var faq = root.querySelector('[id^="ptechFaqWarranty-"]');
          if (faq && !faq.open) faq.open = true;
        }
      });
    });
  }

  function setupPresets(root) {
    var presets = root.querySelectorAll('.ptech-preset');
    presets.forEach(function (b) {
      b.addEventListener('click', function () {
        presets.forEach(function (p) { p.classList.remove('on'); });
        b.classList.add('on');
      });
    });
  }

  /* data-scroll-target="<id>" の汎用ハンドラ */
  function setupScrollLinks(root) {
    var links = root.querySelectorAll('[data-scroll-target]');
    links.forEach(function (el) {
      el.addEventListener('click', function (e) {
        var id = el.getAttribute('data-scroll-target');
        if (!id) return;
        var target = document.getElementById(id);
        if (!target) return;
        e.preventDefault();
        scrollToEl(target);
      });
    });
  }

  function scrollToEl(target) {
    var headerEl = document.querySelector('.header-section, .site-header, header.shopify-section-group-header-group');
    var headerH = headerEl ? headerEl.offsetHeight : 0;
    var rect = target.getBoundingClientRect();
    var top = rect.top + window.scrollY - headerH - 12;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }

  onReady(function () {
    var root = document.querySelector('.ptech.wrap');
    if (!root) return;
    setupGallery(root);
    setupTabs(root);
    setupPresets(root);
    setupScrollLinks(root);
  });
})();
